import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';
import { assertNever } from 'owa-assert';

export const MAX_CONTENT_TO_SHOW = 10;
export const WIDTH_OF_EACH_TILE = 242;
export const RIGHT_PADDING_OF_EACH_TILE = 8;

export const MAX_CONTENT_TO_SHOW_INITIALLY_GROUP = 3;
export const MAX_CONTENT_TO_SHOW_INITIALLY_SINGLE = 1;
export const MAX_CONTENT_TO_SHOW_INITIALLY_OPX = 3;

export function getMaxInsightsToShowOnInitialRender(
    insightsEntrySource: InsightsDataFetchSource
): number {
    if (isHostAppFeatureEnabled('showMinimumThreeInsights')) {
        return MAX_CONTENT_TO_SHOW_INITIALLY_OPX;
    }

    let insightsToShow = 0;
    switch (insightsEntrySource) {
        case InsightsDataFetchSource.ItemPeek:
        case InsightsDataFetchSource.AgendaView:
            insightsToShow = MAX_CONTENT_TO_SHOW_INITIALLY_SINGLE;
            break;
        case InsightsDataFetchSource.ReadingPane:
        case InsightsDataFetchSource.CalendarCard:
        case InsightsDataFetchSource.PrefetchOnCalendarSelected:
        case InsightsDataFetchSource.Reminder:
        case InsightsDataFetchSource.Deeplink:
        case InsightsDataFetchSource.PrefetchOnAgendaView:
        case InsightsDataFetchSource.TimePanelEventDetails:
            insightsToShow = MAX_CONTENT_TO_SHOW_INITIALLY_GROUP;
            break;
        default:
            assertNever(insightsEntrySource);
            break;
    }
    return insightsToShow;
}
